import { render, staticRenderFns } from "./sportsSettings.vue?vue&type=template&id=09e572d3&scoped=true"
import script from "./sportsSettings.vue?vue&type=script&lang=js"
export * from "./sportsSettings.vue?vue&type=script&lang=js"
import style0 from "./sportsSettings.vue?vue&type=style&index=0&id=09e572d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e572d3",
  null
  
)

export default component.exports